import { css } from '@emotion/css';

export const tagButtonStyles = css`
  &.Mui-focusVisible {
    background-color: var(--divider);
  }
`;
